<template>
  <b-container fluid>
    <h3 class="mt-2">ToDo</h3>
    <b-alert class="w-50 ml-auto mr-auto mt-3" show>
      <font-awesome-icon :icon="['fas', 'tools']" /> Under Construction...
    </b-alert>
  </b-container>
</template>

<script>
export default {
  name: 'ToDoView',
};
</script>

<style scoped></style>
